import React from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./style.css";
//import Form from "react-bootstrap/Form";
//import Button from "components/Button/Button";
import { ToggleButton, ToggleButtonGroup, Badge, Row, Col, ButtonToolbar, ButtonGroup, Button, Card } from "react-bootstrap";
// , Image, Container
//import Row from "react-bootstrap/Row";
//import Col from "react-bootstrap/Col";

import { BroadcastChannel } from 'broadcast-channel';

import ReactTooltip from 'react-tooltip';

//import logo from "Assets/loginLogo.svg";
import { assembleNickname } from "utils/Helper";
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
//import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import axios from "axios";
//import { origin } from "utils/Helper";
//import {
//  environment,
//  HeaderConfig
//} from "Api/Api";
//import { apiUrl, myHeaders_Autorized, HeaderConfig, location_api, myHeaders_With_Cache_Control,search_Presentation_API } from "Api/Api";
import { org_friendly_url, user_access_level, user_Status, apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// , HeaderConfig, location_search, User_Patch_Api, user_entity_uuid, myHeaders_Authorized
//import geoLocation from 'utils/geoLocation';
import { local_routes } from 'utils/Routes';

//const locationSearchAPI = environment.location_Search;
//const User_Patch_Api = environment.User_Patch_Api;

import EventImg from 'Assets/event-img.jpg';

import UserContext from 'store/UserContext';

class RunOfShowPlay extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      event_uuid: '',
      innerHeight: window.innerHeight,
      player_muted: false,
      show_controls_in_player: false,
      runofshow_leaves: [],
      current_leaf_index: parseInt(props.match.params.start_leaf-1) || 0,
      loading: true,
      event_friendly_url: props.match.params.friendly_url.toLowerCase(),
      user_clicked: false,
      //show_allow_autoplay_button: false
    };

    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }

    this.channel = new BroadcastChannel('event_runofshow_'+this.state.event_friendly_url);
    this.channel.onmessage = msg => this.handleControlMessage(msg);
    
    // send ack immediately to let controller know we are here
    let channel_msg = {
      cmd: 'ack'
    }
    this.channel.postMessage(JSON.stringify(channel_msg));
    
    this.video_ref = React.createRef();
    this.video_played = false;
    
    this.image_dimensions = '2250x1080';
    
    window.addEventListener('resize', this.handleResize);
  }
  
  handleResize = () => {
    console.log("handleResize");
    this.setState({
      innerHeight: window.innerHeight
    });
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  APICalls = async () => {
    // get runofshow_leaves and pre-load assets
    let api_promises = [];
    
    let params = {
      attributes: ['runofshow_leaves','entity_uuid','entity_name','description','spotlighted_image_url','image_urls','poster_image_url','thumb_image_url']
    };
    //let leaves_response = await axios.get(`${apiUrl}events/${this.state.event_friendly_url}`, { params, ...myHeaders_Auth_With_Cache_Control });
    api_promises.push(axios.get(`${apiUrl}events/${this.state.event_friendly_url}`, { params, ...myHeaders_Auth_With_Cache_Control }));
 
    params = {
      attributes: ['entity_uuid','entity_name','image_url','presentation_video_url','status_code','pad_color','description'],
      do_recursive: true,
      filter_obj: {
          order_integer: {
              gte: 1
          }
      }
    };
    api_promises.push(axios.get(`${apiUrl}events/${this.state.event_friendly_url}/presentations`, { params, ...myHeaders_Auth_With_Cache_Control}));

    
    let [event_response,event_presentations_response] = await Promise.all(api_promises);
    
    console.log("Got event data",event_response.data);

    // put presentations info obj for easy retrieval
    let tmp_presentations_map = {};
    event_presentations_response.data.forEach(element => {
      tmp_presentations_map[element.entity_uuid] = element;
    });

    //if (leaves_response.data.runofshow_leaves && leaves_response.data.runofshow_leaves[this.state.current_leaf_index]) {
    if (event_response.data.runofshow_leaves) {
      let tmp_runofshow_leaves = [...event_response.data.runofshow_leaves];
      // fill in references
      tmp_runofshow_leaves.forEach( element => {
        if (element.leaf_type === 'event_cover') {

          element.leaf_text = [];
          if (event_response.data.spotlighted_image_url) {
            element.leaf_asset_url = event_response.data.spotlighted_image_url;
          } else if (event_response.data.image_urls && event_response.data.image_urls.length > 0) {
            element.leaf_asset_url = event_response.data.image_urls[0];
          } else if (event_response.data.poster_image_url) {
            element.leaf_asset_url = event_response.data.poster_image_url;
          } else if (event_response.data.thumb_image_url) {
            element.leaf_asset_url = event_response.data.thumb_image_url;
          } else {
            element.leaf_asset_url = EventImg;
          }
          
          element.adjusted_leaf_asset_url = element.leaf_asset_url;
          if (element.adjusted_leaf_asset_url.includes(event_response.data.entity_uuid)) {
            let array = element.leaf_asset_url.split("/");
            let pad_color = 'black';
            element.adjusted_leaf_asset_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/pad${pad_color}_noborder_${this.image_dimensions}/${array[5]}`;
          }
          new window.Image().src = element.adjusted_leaf_asset_url;
          if (element.leaf_event_cover_options) {
            if (element.leaf_event_cover_options.smart_overlay) {
              event_response.data.users = [];
              if (this.context.user_info.entity_uuid) {
                event_response.data.users[0] = this.context.user_info;
                element.leaf_text = this.assembleSmartOverlayCardText(event_response.data);
              } else {
                element.leaf_text = ['Loading'];
              }
            } else {
              element.leaf_text = this.assembleCustomCardText(element.leaf_event_cover_options.custom_overlay_description);
            }
          }

        } else if (element.leaf_type === 'presentation_cover') {
          if (!tmp_presentations_map[element.leaf_presentation_uuid]) {
            return;
          }
          element.leaf_text = [];
          element.leaf_asset_url = tmp_presentations_map[element.leaf_presentation_uuid].image_url;
          let array = element.leaf_asset_url.split("/");
          let pad_color = 'black';
          if (tmp_presentations_map[element.leaf_presentation_uuid].pad_color) {
            //pad_color = tmp_presentations_map[element.leaf_presentation_uuid].pad_color;
          }
          element.adjusted_leaf_asset_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/pad${pad_color}_noborder_${this.image_dimensions}/${array[5]}`;
          new window.Image().src = element.adjusted_leaf_asset_url;
          if (element.leaf_presentation_cover_options) {
            if (element.leaf_presentation_cover_options.smart_overlay) {
              element.leaf_text = this.assembleSmartOverlayCardText(tmp_presentations_map[element.leaf_presentation_uuid]);
            } else {
              element.leaf_text = this.assembleCustomCardText(element.leaf_presentation_cover_options.custom_overlay_description);
            }
          }
        } else if (element.leaf_type === 'image') {
          let array = element.leaf_asset_url.split("/");
          element.adjusted_leaf_asset_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_noborder_${this.image_dimensions}/${array[5]}`;
          if (element.leaf_image_options) {
            if (element.leaf_image_options.custom_overlay_description) {
              element.leaf_text = this.assembleCustomCardText(element.leaf_image_options.custom_overlay_description);
            }
          }
        } else if (element.leaf_type === 'presentation_video') {
          if (!tmp_presentations_map[element.leaf_presentation_uuid]) {
            return;
          }
          element.leaf_asset_url = tmp_presentations_map[element.leaf_presentation_uuid].presentation_video_url;
        }
        
        
      });
      this.setState({
        //runofshow_leaves: leaves_response.data.runofshow_leaves || [],
        event_uuid: event_response.data.entity_uuid || '',
        runofshow_leaves: tmp_runofshow_leaves || [],
        current_leaf_index: (tmp_runofshow_leaves.length-1) < this.state.current_leaf_index ? tmp_runofshow_leaves.length-1 : this.state.current_leaf_index,
        loading: false
      }, () => this.props.history.replace( { pathname: this.workspace_base_url+'/runofshowplay/'+this.state.event_friendly_url+'/'+(this.state.current_leaf_index+1)} ));
    }    
  }
  
  assembleCustomCardText = (custom_overlay_description) => {
    let custom_overlay_description_array = custom_overlay_description.split(/\r?\n/g);
    custom_overlay_description_array = custom_overlay_description_array.map( element => (
      <React.Fragment><span style={{ padding: "2px", background: "rgba(0, 0, 0, 0.7)" }}>{element}</span><br/></React.Fragment>
    ));
    console.log("assembleCustomCardText",custom_overlay_description_array);
    return custom_overlay_description_array;
  }
  
  assembleSmartOverlayCardText = (entity_info) => {
    //let leaf_text = [];
    
    let adjusted_avatar_image_url = "";
    
    if (entity_info.users[0].avatar_image_url) {
      let array = entity_info.users[0].avatar_image_url.split("/");
      adjusted_avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_125x125/${array[5]}`;
      new window.Image().src = adjusted_avatar_image_url;
      //leaf_text.push(<img style={{ borderRadius: "50%" }} src={adjusted_avatar_image_url}/>);
    }
    entity_info['description'] = entity_info['description'].replace(/<[^>]+>/g, '');
    if (entity_info['description'].length > 512) {
      entity_info['description'] = entity_info['description'].substring(0,512)+'...';
    }
    
    let leaf_text = 
          <Row className="flex-nowrap">
            { adjusted_avatar_image_url &&
              <Col xs={2} >
                <img style={{ background: "rgba(0, 0, 0, 0.7)", borderRadius: "50%", float: "none", width: "100%" }} src={adjusted_avatar_image_url} alt="img"  />
              </Col>
            }
            <Col xs={adjusted_avatar_image_url ? 10 : 12}>
              <span style={{ fontWeight: "bolder", fontSize: "larger", padding: "2px", background: "rgba(0, 0, 0, 0.7)" }}>{entity_info.entity_name}</span><br/>
              <span style={{ fontWeight: "bolder", padding: "2px", background: "rgba(0, 0, 0, 0.7)" }}>by {assembleNickname(entity_info.users[0])}</span><br/>
              <span style={{ padding: "2px", background: "rgba(0, 0, 0, 0.7)" }}>{entity_info['description']}</span>
            </Col>
          </Row>
    
    /*
    leaf_text.push(<span style={{ fontSize: "larger", padding: "2px", background: "rgba(0, 0, 0, 0.7)" }}>{presentation_info.entity_name}</span>);
    leaf_text.push(<span style={{ padding: "2px", background: "rgba(0, 0, 0, 0.7)" }}>by {assembleNickname(presentation_info.users[0])}</span>);
    leaf_text.push(<span style={{ padding: "2px", background: "rgba(0, 0, 0, 0.7)" }}>{presentation_info['description']}</span>);
    if (presentation_info.users[0].avatar_image_url) {
      let array = presentation_info.users[0].avatar_image_url.split("/");
      let adjusted_avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_125x125/${array[5]}`;
      leaf_text.push(<img style={{ borderRadius: "50%" }} src={adjusted_avatar_image_url}/>);
    }
    */

    return [leaf_text];    
  }

  async componentDidMount() {
    //await this.APICalls();
  }
  
  async componentDidUpdate(prevProps) {
    if (this.context.user_info.entity_uuid && !this.state.event_uuid) {
      await this.APICalls();
    }
    //console.log("componentDidUpdate",prevProps,this.props);
  }
  
  handleControlMessage = async (msg) => {
    console.log("handleControlMessage",msg);
    let cmd_obj = {};
    try {
      cmd_obj = JSON.parse(msg);
    } catch (err) {
      console.error("ERROR parsing JSON",err,msg);
      return;
    }
    
    if (!cmd_obj.cmd) {
      console.error("INVALID cmd",cmd_obj);
      return;
    }
    
    let new_leaf_index = null;
    
    switch (cmd_obj.cmd) {
      case "refresh_leaves": {
        await this.APICalls();
        break;
      }
      case "jump_to_leaf": {
        if (cmd_obj.leaf_index !== undefined) {
          new_leaf_index = cmd_obj.leaf_index;
        }
        break;
      }
      /*
      case "next_leaf": {
        if (this.state.current_leaf_index < (this.state.runofshow_leaves.length - 1)) {
          new_leaf_index++;  
        }
        break;
      }
      case "prev_leaf": {
        if (this.state.current_leaf_index > 0) {
          new_leaf_index--;
        }
        break;
      }
      */
      case "play_video": {
        if (this.video_ref.current) {
          try {
            await this.video_ref.current.play();
          } catch (err) {
            console.error("ERROR playing video",err);
          }
        }
        break;
      }
      case "pause_video": {
        if (this.video_ref.current) {
          try {
            this.video_ref.current.pause();
          } catch (err) {
            console.error("ERROR pausing video",err);
          }
        }
        break;
      }
      case "toggle_controls": {
        if (cmd_obj.show_controls !== undefined) {
          this.setState({
            show_controls_in_player: cmd_obj.show_controls
          });
        }
        break;
      }
      case "toggle_mute": {
        if (cmd_obj.muted !== undefined) {
          if (this.video_ref.current) {
            try {
              this.video_ref.current.muted = cmd_obj.muted;
            } catch (err) {
              console.error("ERROR muting video",err);
            }
          }
          this.setState({
            player_muted: cmd_obj.muted
          })
        }
        break;
      }

      case "ack": {
        // do callback ack
        let channel_msg = {
          cmd: 'ack'
        }
        this.channel.postMessage(JSON.stringify(channel_msg));
        break;
      }
    }
    
    if (new_leaf_index !== null) {
      this.setState({
        current_leaf_index: new_leaf_index
      });
      
      this.props.history.replace( { pathname: this.workspace_base_url+'/runofshowplay/'+this.state.event_friendly_url+'/'+(new_leaf_index+1)} );
    }
  }
  
  handlePlay = async (event) => {
    console.log("handleFirstPlay",event.target);

    try {
      await this.video_ref.current.play();
      this.setState({
        user_clicked: true
      });
    } catch (err) {
      console.error("video play() failed");
      this.setState({
        user_clicked: false
      })      
    }
  }

  renderLeafCard = () => {
    let leaf_info = this.state.runofshow_leaves[this.state.current_leaf_index];
    
    let tmp_leaf_text = [];
    if (leaf_info.leaf_text && leaf_info.leaf_text.length > 0) {
      tmp_leaf_text = leaf_info.leaf_text;
    }
    
    return (
      <Card style={{ border: "none" }} key={this.state.current_leaf_index} className="bg-dark text-white">
        <Card.Img src={leaf_info.adjusted_leaf_asset_url} alt="Card image" />
        <Card.ImgOverlay>
          <Card.Body>
            <Card.Title><Badge variant="dark">{this.state.current_leaf_index+1} / {this.state.runofshow_leaves.length}</Badge></Card.Title>
              { tmp_leaf_text.map( (element,index) => (
                <React.Fragment key={index}>{element}</React.Fragment>
              ))}
          </Card.Body>
        </Card.ImgOverlay>
      </Card>
    );
  };

  renderLeaf = () => {
    let content = [];
    let leaf_info = this.state.runofshow_leaves[this.state.current_leaf_index];
    
    console.log("renderLeaf",leaf_info);
    
    switch (leaf_info.leaf_type) {
      case "image": {}
      case "event_cover": {}
      case "presentation_cover": {
        content.push(this.renderLeafCard());
        //content.push(
        //  <Image key={0} src={leaf_info.adjusted_leaf_asset_url} width="100%" height="100%" fluid />
        //);
        break;
      }
      case "video": {}
      case "presentation_video": {
        content.push(

            <video
              //defaultmuted={this.state.player_muted}
              muted={this.state.player_muted}
              style={{ objectFit: "contain", paddingTop: "10px",paddingBottom: "5px" }}
              key={0} src={leaf_info.leaf_asset_url}
              controls
              ref={this.video_ref}
              autoPlay
              onPlay={this.handleFirstPlay}
            />

        );
        break;
      }
    }
    
    return content;
  }
  
  userClicked = () => {
    this.setState({
      user_clicked: true
    })
  }
  
  handleScrollTo = (leaf_index) => {
      let channel_msg = {
        cmd: 'jump_to_leaf',
        leaf_index
    }
    this.postChannelMessage(channel_msg);
  }
  
  onChangePlayerMute = (event) => {
    this.postChannelMessage({cmd:'toggle_mute',muted:!this.state.player_muted});
    //this.setState({player_muted:!this.state.player_muted});
  }
  
  handlePlayVideo = (leaf_index) => {
      let channel_msg = {
          cmd: 'play_video'
      }
      this.postChannelMessage(channel_msg);
  }
  handlePauseVideo = (leaf_index) => {
      let channel_msg = {
          cmd: 'pause_video'
      }
      this.postChannelMessage(channel_msg);
  }
  
  postChannelMessage = (msg_obj) => {
    this.handleControlMessage(JSON.stringify(msg_obj));
    this.channel.postMessage(JSON.stringify(msg_obj));
  }

  renderPlayerControls = () => {
    return (
      <Row ref={this.leaves_anchor_ref} style={{ backgroundColor: "gray", paddingTop: "3px", paddingBottom: "3px" }} className="">
            <Col xs={8}>
                <ButtonToolbar>
                    <ButtonGroup size="sm" style={{ flexWrap: "wrap" }}>
                        { this.state.runofshow_leaves.map( (leaf_info, index ) => (
                            <Button
                                size="sm"
                                onContextMenu={(e)=>  {e.preventDefault();}}
                                //data-place="right"
                                data-tip={leaf_info.leaf_name}
                                style={this.state.runofshow_leaves.length > 10 ? { maxWidth: "30px" } : { maxWidth: "40px" }}
                                size={this.state.runofshow_leaves.length > 10 ? 'sm' : 'md'}
                                disabled={this.state.global_editing && !leaf_info.editing}
                                key={index}
                                variant={leaf_info.editing ? "info" : this.state.current_leaf_index === index ? "pkprimary" : "secondary"}
                                //onClick={(event) => this.handleScrollTo(index,event)}
                                onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handleScrollTo(index,event)}}
                            >
                                {index+1}
                            </Button>
                        ))}
                    </ButtonGroup>
                    <ButtonGroup size="sm" style={{ marginLeft: "10px", flexWrap: "wrap" }}>
                      <Button
                          size="sm"
                          onContextMenu={(e)=>  {e.preventDefault();}}
                          disabled={this.state.current_leaf_index === 0}
                          //data-place="right"
                          data-tip={'Go Back One Slide'}
                          //style={this.state.runofshow_leaves.length > 10 ? { maxWidth: "30px" } : { maxWidth: "40px" }}
                          size={this.state.runofshow_leaves.length > 10 ? 'sm' : 'md'}
                          //disabled={this.state.global_editing}
                          //key={index}
                          variant={"pkprimary"}
                          //onClick={(event) => this.handleScrollTo(index,event)}
                          onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handleScrollTo(this.state.current_leaf_index-1,event)}}
                      >
                          <i className="fa fa-step-backward" aria-hidden="true"></i>
                      </Button>
                      <Button
                          size="sm"
                          onContextMenu={(e)=>  {e.preventDefault();}}
                          disabled={this.state.current_leaf_index === this.state.runofshow_leaves.length-1}
                          //data-place="right"
                          data-tip={'Go Forward One Slide'}
                          //style={this.state.runofshow_leaves.length > 10 ? { maxWidth: "30px" } : { maxWidth: "40px" }}
                          size={this.state.runofshow_leaves.length > 10 ? 'sm' : 'md'}
                          //disabled={this.state.global_editing}
                          //key={index}
                          variant={"pkprimary"}
                          //onClick={(event) => this.handleScrollTo(index,event)}
                          onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handleScrollTo(this.state.current_leaf_index+1,event)}}
                      >
                          <i className="fa fa-step-forward" aria-hidden="true"></i>
                      </Button>
                    </ButtonGroup>
                </ButtonToolbar>
            </Col>
            <Col xs={4}>
                <Row>
                  <ToggleButtonGroup
                    onContextMenu={(e)=> {e.preventDefault();}}
                    size="sm"
                    //style={{marginRight: "10px"}}
                    type="checkbox"
                    //onChange={() => {this.setState({show_controls_in_player:!this.state.show_controls_in_player})}}
                    onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.onChangePlayerMute(event)}}
                  >
                    <ToggleButton
                        size="sm"
                        //type="checkbox"
                        variant="secondary"
                        checked={this.state.player_muted}
                        value="1"
                        //onChange={(e) => setChecked(e.currentTarget.checked)}
                    >
                      {this.state.player_muted ? 'Unmute Player Video' : 'Mute Player Video'}
                    </ToggleButton>
                  </ToggleButtonGroup>                         
                  { (this.state.runofshow_leaves.length > 0 && this.state.runofshow_leaves[this.state.current_leaf_index].leaf_type.endsWith("video")) &&
                      <React.Fragment>
                      <Button
                          onContextMenu={(e)=>  {e.preventDefault();}}
                          //data-place="right"
                          data-tip={'Play Video'}
                          style={{ marginLeft: "5px" }}
                          size="sm"
                          variant="pkprimary"
                          //onClick={this.handlePlayVideo}
                          onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handlePlayVideo(event)}}
                      >
                          <i className="fa fa-play" aria-hidden="true"></i>
                      </Button>
                      <Button
                          onContextMenu={(e)=>  {e.preventDefault();}}
                          //data-place="right"
                          data-tip={'Pause Video'}
                          size="sm"
                          variant="pkprimary"
                          //onClick={this.handlePauseVideo}
                          onMouseDown={(event) => {event.preventDefault(); event.stopPropagation(); this.handlePauseVideo(event)}}
                      >
                          <i className="fa fa-pause" aria-hidden="true"></i>
                      </Button>
                      </React.Fragment>
                  }
                </Row>
            </Col>
            <ReactTooltip effect="solid" place="right"/>
        </Row>
    );
  }

  render() {
    if (this.state.loading || (user_Status && !this.context.user_info.entity_uuid)) {
        return (
            <div className="spinner-pos">
                <FullPageSpinner />
            </div>
        );
    }
    
    if (user_access_level !== 'admin' && (!user_Status || !this.context.user_info.events.some( element => element.entity_uuid === this.state.event_uuid ))) {
      // not an event admin! not allowed
      return (
          <div className="spinner-pos">
              <h1>Access Not Allowed</h1>
          </div>
      );
    }
    
    let isMac = window.navigator.platform.indexOf('Mac') > -1;

    //let viewport_height = window.innerHeight;
    //if (this.state.show_controls_in_player) {
      //viewport_height -= 36;
    //}

    return (
      <React.Fragment>
        <Helmet>
          <title>PechaKucha Event Player</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
          { this.state.show_controls_in_player &&
            this.renderPlayerControls()
          }
        <div onClick={this.userClicked} style={{ backgroundColor: "black", height: this.state.show_controls_in_player ? (this.state.innerHeight - 46) : this.state.innerHeight }} className="flex-center">

          {!this.state.user_clicked ?
              <div>
                <h1 style={{ color: "lightgray" }}>Please Click to Enable Video Autoplay</h1>
                { isMac &&
                  <h2 style={{ color: "lightgray" }}>If using player controls from the event management page, please right-click the controls to maintain focus on the player window.</h2>
                }
                <h2 style={{ color: "lightgray" }}>Resize and reposition controls and player as needed.</h2>
                <h2 style={{ color: "lightgray" }}>In-player control bar can be enabled/disabled from the event management page.</h2>
              </div>
            :
            <React.Fragment>
              {this.renderLeaf()}
            </React.Fragment>
          }
        </div>
        {/*
        <Container style={{ height: "100vh" }} fluid>
          <Row className="align-items-center justify-content-between">
            <Col style={{ width: "90%" }} xs={12}>
            { this.state.current_leaf_index === null ?
              <h1>No Leaf to Show</h1>
              :
              this.renderLeaf()
            }
            </Col>
          </Row>
        </Container>
        */}
      </React.Fragment>
    );
  }
}

export default withRouter(RunOfShowPlay);
